'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _colors2 = require('./_colors');

var _colors3 = _interopRequireDefault(_colors2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var etc = {
  paddingCoreViewportTop: '70px',

  paddingPanelBase: 25,

  paddingModalBase: 30,
  paddingModalHorizontal: '72px',

  defaultShadow: '3px 3px 9px 1px rgba(50, 50, 50, 0.15)',
  cardShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
  cardBorderWidth: '1px',

  fontSizeSmall: '13px',
  fontSizeLarge: '16px',
  fontSizeXLarge: '18px',
  fontSizeXXLarge: '20px',
  tableFontSize: '14px',

  fontWeightBold: 700,
  fontWeightSemibold: 600,
  fontWeightNormal: 400,

  inputBorderRadius: '2px',
  inputHeight: '3.5rem',
  inputTextSm: '14px',
  inputTextLg: '20px',
  inputLineHeightSm: '20px',
  inputLineHeightLg: '32px',

  screenXs: '480px',
  screenSm: '768px',
  screenMd: '992px',
  screenLg: '1200px',

  headerHeight: 70,
  layout: {
    headerHeight: 120,
    fixedHeaderHeight: 85
  },

  sidebarPaddingHorizontal: '24px',
  sidebarLeftBorder: '5px',
  sidebarLinkPaddingHorizontal: '19px',

  defaultButtonHeight: '4rem'
};

var typography = {
  htmlBaseFontSize: '8px',
  bodyBaseFontSize: '16px',
  smallTagEm: '0.75em',
  paragraphEm: '1em',
  extraLargeEm: '1.5em',
  largeEm: '1.25em',
  mediumEm: '1em',
  smallEm: '0.875em',
  extraSmallEm: '0.75em',
  baseLetterSpacing: 'initial',
  halfLetterSpacing: '0.5px',
  fontFamily: 'Open Sans',
  baseLineHeight: '3rem',
  largeLineHeight: '4rem',
  smallLineHeight: '2.5rem',
  extraSmallLineHeight: '2rem',
  textCase: 'uppercase',
  fontColorDarkGray: _colors3.default.grayDarker,
  fontColorGray: _colors3.default.grayDark
};

etc.paddingPanelTop = etc.paddingPanelBase + 'px';
etc.paddingPanelBottom = etc.paddingPanelBase + 15 + 'px';
etc.paddingPanelHorizontal = etc.paddingPanelBase + 5 + 'px';
etc.paddingPanelBase = etc.paddingPanelBase + 'px';

etc.paddingModalTop = etc.paddingModalBase + 'px';
etc.paddingModalBottom = etc.paddingModalBase + 15 + 'px';
etc.paddingModalBase = etc.paddingModalBase + 'px';

exports.default = _extends({}, etc, typography);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/styles/js/_etc.js
// module id = 904
// module chunks = 14